import { COLORS } from '../../../../../shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    padding: 20px;
    gap: 16px;
    border-radius: 20px;
    border: 1px solid ${COLORS.neutral_10};
    flex-direction: column;
`;

export const List = styled('div')`
    display: flex;
    gap: 20px 40px;
    flex-wrap: wrap;
`;

export const ItemList = styled('a')`
    display: flex;
    gap: 12px;
    align-items: center;

    &:hover > button {
        color: ${COLORS.primary_70};
    }

    &:active > button {
        color: ${COLORS.primary_80};
    }
`;
